// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BulkDeleteController from "./bulk_delete_controller"
application.register("bulk-delete", BulkDeleteController)

import ChangeDurationController from "./change_duration_controller"
application.register("change-duration", ChangeDurationController)

import ChangePlanController from "./change_plan_controller"
application.register("change-plan", ChangePlanController)

import ChangePlanModalController from "./change_plan_modal_controller"
application.register("change-plan-modal", ChangePlanModalController)

import RecordReadingFormController from "./record_reading_form_controller"
application.register("record-reading-form", RecordReadingFormController)
